import React, {useEffect, useState} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {backupsRuntime} from "../../../utils/gridColumnDefs/backups/backupsRuntime";
import {useSearchParams} from "react-router-dom";
import DumbbellSeries from "../../../components/DumbbellSeries";
import {Card} from "reactstrap";

export default function BackupRuntime({context, title}) {

    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [searchParams] = useSearchParams();

    const [chartData, setChartData] = useState([]);
    const [formattedChartData, setFormattedChartData] = useState([]);
    const [scrollHeight, setScrollHeight] = useState(0);

    let route = `/api/v6/report/backup_run_time_proc?client_id=${client.clientId}&period_id=${periodId}`;

    const [data] = useDataWithRoute(route);

    useEffect(() => {
        setChartData(data?.recordset);
        handleStateWithData(data?.recordset || []);
    }, [data, searchParams]);

    const handleStateWithData = data => {
        let lowToHigh = data.map(datum => {
            return {
                name: datum.backup_job_name,
                staticLow: datum.shortest_run_time,
                low: datum.shortest_run_time,
                mid: datum.most_recent_run_time,
                high: datum.longest_run_time
            };
        });
        let midToHigh = data.map(datum => {
            return {
                name: datum.backup_job_name,
                staticLow: datum.shortest_run_time,
                low: datum.most_recent_run_time,
                mid: datum.most_recent_run_time,
                high: datum.longest_run_time
            };
        });

        if (lowToHigh.length > 400) {
            lowToHigh.length = 400
            midToHigh.length = 400
        }
        
        if (data && !scrollHeight) {
            setScrollHeight(lowToHigh.length * 20);
        }

        setFormattedChartData([{
            name: "Backup Runtime",
            data: lowToHigh,
            lowColor: '#B0EA3B'
        },
        {
            name: "Backup Runtime",
            data: midToHigh,
            lowColor: '#0066b5',
            color: 'none',
            marker: {
                fillColor: '#ff8d02',
                symbol: 'circle'
            }
        }]);
    };

    const filterChanged = (eventData) => {
        let rowData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            rowData.push(node.data);
        });

        handleStateWithData(rowData || []);
    };

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Backup Runtime</VsiH4>
        <VsiBubble autobotName='DumbbellSeries'>
            <DumbbellSeries
                series={formattedChartData}
                yTitle={'Runtime (mins)'}
                xTitle={'Job Name'}
                height={500}
                formatPoint={`{series.name}: {point.staticLow} - {point.high} min(s)<br> Most recent: {point.mid} min(s)`}
                scrollHeight={scrollHeight}
            />
        </VsiBubble>
        <VsiBubble>
            <Grid
                data={chartData}
                columnDefs={backupsRuntime}
                filterChanged={filterChanged}
            />
        </VsiBubble>

    </Card>
}
